


class RegisterLogin extends Backbone.View {

    get el() {
        return 'body';
    };

    get events() {
        return {
            'form submit': 'submit_handler',
            'click button.register': 'submit_handler',
            'click #facebook_account_auth': 'facebook_connect',
            'click #google_plus_account_auth': 'google_plus_connect',
            'click #forgot_password': 'forgot_password',
            'tap #toggle_password': 'toggle_password',
            'click #toggle_password': 'toggle_password'
        };
    };

    initialize () {
        this.submitting = false;
        $('#id_email').focus()
    };

    submit_handler (e) {
        if (this.submitting) {
            e.preventDefault();
            return;
        }

        this.submitting = true;

        this.submit_form();
    };

    get submit_form() {
        return _.debounce(() => this.submitting = false, 1000);
    };

    facebook_connect (e) {
        e.preventDefault();

        window.sign_in_view.facebook_connect({
            onConnect: () => {
                let next = getURLParameter('next');
                if (next) {
                    window.parent.location = next;
                } else {
                    window.location = '/';
                }
            }
        });
    };

    google_plus_connect (e) {
        e.preventDefault();

        window.sign_in_view.google_plus_connect({
            onConnect: () => {
                let next = getURLParameter('next');
                if (next) {
                    window.parent.location = next;
                } else {
                    window.location = '/';
                }
            }
        });
    }

    forgot_password () {
        window.forgot_modal = new SecureModal({
            url: urls.get('forgot_modal'),
            onOpen: function(iframe) {
                return iframe.find('#id_email').val($('#id_email').val());
            }
        });
        window.forgot_modal.show();
    };

    toggle_password (e) {
        e.preventDefault();
        $('#passwords').toggleClass('shown');
        var pwType = $('#id_password').closest('#passwords').hasClass('shown') ? 'text' : 'password';
        $('#id_password').attr("type", pwType);
        return false
    };
};

export default RegisterLogin


// WEBPACK FOOTER //
// ./assets/es6/auth/register-login.es6